import React, { useEffect, useState } from 'react';
import WoocommerceAPI from '../../IPSAPI/WoocommerceAPI'; 
import VariablePopup from '../../Orderbumps/VariablePopup'; 
import Orderbumpelement from '../../Orderbumps/Orderbumpelement'; 
import SkeletonContent from '../../Skeleton/SkeletonContent'; 
import SC_ManageData from '../SC_ManageData'; 





function Orderbump({ settings, cartItems}) {

  const [selectedOrderbumps, setSelectedOrderbumps] = useState([]);
  const [showVariablePopup, setShowVariablePopup] = useState(false);
  const [currentOrderbump, setcurrentOrderbump] = useState(false); 
  const [selectedPrice, setSelectedPrice] = useState(null);
  const [orderbumploading, setOrderbumpLoading] = useState(false); 
  const [currentIndex, setCurrentIndex] = useState(null);


  

  const toggleOrderbumpSelection = (index) => {
    const isSelected = selectedOrderbumps.includes(index);
    const updatedSelection = isSelected
      ? selectedOrderbumps.filter((item) => item !== index)
      : [...selectedOrderbumps, index];

    setSelectedOrderbumps(updatedSelection);
  };

  const handleCheckboxChange = async (index, productId, quantity, producttype, orderbump) => {
    if (!selectedOrderbumps.includes(index)) {
    //  console.log("Checkbox Orderbump selected");
      
    //  console.log("Product-ID: ",productId);
    //  console.log("Quantity: ", quantity); 
    //  console.log("Producttype: ", producttype); 
      setCurrentIndex(index);

    
  
      try {

        if (producttype === 'variable') {
          // Wenn der Producttyp 'variable' ist, zeige das Popup an
          setcurrentOrderbump(orderbump);
          setShowVariablePopup(true);
          
          return; // Popup anzeigen und Funktion beenden
        }else{
          setcurrentOrderbump(orderbump);
        }
        

  


       // console.log("Übertrage Product-ID und Menge: ", productId + ', ' + quantity);
       //console.log("HandleCheckboxChange");
      



      orderbumpAddToCart(productId, quantity, producttype, null, orderbump);
  
      
      
     
       //console.log("Orderbump fetch");
       // fetchData(); // Neu Daten laden
      } catch (error) {
        console.error('Error removing product from cart:', error);
      }
    }
  };


  /* ************************************************************************************************************/
/* ********************** Das Product wird vom Button das erste Mal in die Sidecart gelegt ********************/


const orderbumpAddToCart = async (productId, quantity, producttyp, selectedOptions = null, thisorderbump = null) => {


//------------------------------------------------------------------------------------------------

let orderbumpsettings = [];
let quantityupdate = false;
let discountTyp = 'option-1';
let discount = 0;
let discountreduced = 0;
let orderbump_postid = 0;

const roundToTwoDecimalPlaces = (number) => {
  return +(Math.round(Number.parseFloat(number) + "e+2")  + "e-2");
}




//---------- DISCOUNT STUFF ----------------------------------------------------------------------

if(thisorderbump && thisorderbump[0] && thisorderbump[0]['ips-mb-ordebumps-offer-calcdiscount'] !== undefined && parseFloat(thisorderbump[0]['ips-mb-ordebumps-offer-calcdiscount']) > 0) {
discountTyp = thisorderbump[0]['ips-mb-ordebumps-offer-discounttyp'];         // 'option-1' => 'Percent Off',    'option-2' => 'Amount Off',
discount = parseInt(thisorderbump[0]['ips-mb-ordebumps-offer-discountprice']);

let discountreduced_tmp = parseFloat(thisorderbump[0]['ips-mb-ordebumps-offer-calcdiscount-notax']);    // the new discount price (Already calced)
discountreduced = roundToTwoDecimalPlaces(discountreduced_tmp);
//discountreduced = parseFloat(parseFloat(thisorderbump[0]['ips-mb-ordebumps-offer-calcdiscount']).toFixed(2));
//console.log("Discount Typ: ",discountTyp);  // option-1 => Prozentualer Abzug; option-2 => Fixer Betrag Abzug (kleinster 0€); 
  //  console.log("Discount: ",discount);
    //console.log("Discount reduced new: ",discountreduced);

}else{
     // console.log("No Discount");
     }
     
 
   //  console.log("All Orderbump-SETS: ",thisorderbump);

  //-----------------------------------------------------------------------------------------------------------
  //--------------------------------- Orderbump item in cart update possible ----------------------------------

 // console.log("Orderbump Array: ",thisorderbump);
  if(thisorderbump && thisorderbump[0]){
   // console.log("Do some orderbump update");
    let quantityupdate_tmp = thisorderbump[0]['ips-mb-ordebumps-offer-update'];
    quantityupdate = quantityupdate_tmp === '1' ? true : false;
   // orderbumpsettings.push(['quantityupdate', quantityupdate]);
   // orderbumpsettings.push(['quantityupdate_test2', 'yes']);
  

  }

  orderbump_postid = parseInt(thisorderbump[0]['ips-mb-ordebumps-metadata-orderbump-postid']);


  //----------------------------------------------------------------------------------------------------------

  orderbumpsettings = {
    quantityupdate: quantityupdate,
    discounttyp:  discountTyp,
    discount:     discount,
    discountreduced: discountreduced,
    orderbump_postid: orderbump_postid,
};

  //console.log("Orderbumpsettings: ",orderbumpsettings);


  try {
   // console.log("");
   // console.log("<<<>-<>-<>-<>-<>-<>-<>-<>>>");
   // console.log("Übertrage Product-ID, Menge und Typ: ",productId+', '+quantity+', '+producttyp);
    //setLoading(true);

   

    setOrderbumpLoading(true);
    const response =  await WoocommerceAPI.addToCart(settings.base_url, productId, quantity, producttyp, cartItems.key, selectedOptions, null, orderbumpsettings);
    setOrderbumpLoading(false);



    SC_ManageData.fetchDataDirect(response);
    setShowVariablePopup(false);
    setSelectedOrderbumps([]);

    
    //fetchData(); // Neu Daten laden
  } catch (error) {
    console.error('Error removing product from cart:', error);
  }
};








const shouldRenderOrderbump = (orderbump, index) => {

  let doOrderbump = true;

  const productId = parseInt(orderbump[0]['ips-mb-ordebumps-offer-product'], 10);
 // console.log("Orderbump ID: ",productId);
  if (!cartItems) {
   // console.log("Cartitems empty");
    // Wenn cartItems nicht vorhanden sind, rendern Sie den Orderbump
    return <Orderbumpelement orderbump={orderbump} index={index} productId={productId} currency={settings.currency} selectedOrderbumps={selectedOrderbumps} toggleOrderbumpSelection={toggleOrderbumpSelection} handleCheckboxChange={handleCheckboxChange}/>;
  }

 
  // ----------------------------------------------------------------------------------------------------------
  // -------------- SETTINGS | Orderbump is in cart | etc. ----------------------------------------------------
  // ----------------------------------------------------------------------------------------------------------

  doOrderbump = SC_ManageData.validateOrderbump(orderbump,cartItems);
  
  /* const isProductInCart = cartItems.some((item) => item.id === productId || item.variationid === productId);
  const excludedProducts = orderbump[0]['ips-mb-ordebumps-display-excludproducts'];
  const specificProducts = orderbump[0]['ips-mb-ordebumps-display-specproducts'];

  //console.log("isProductInCart: ",isProductInCart);
  //console.log("excludedProducts: ",excludedProducts);
  //console.log("specificProducts: ",specificProducts);

  if (!isProductInCart){
    
    
    if(excludedProducts || specificProducts){


    if(specificProducts){
      doOrderbump = isProductIncluded(specificProducts, cartItems);

    }
    if(excludedProducts && doOrderbump){
      doOrderbump = !isProductIncluded(excludedProducts, cartItems);

    }
    
  }else{
    doOrderbump = true;

  }


  }else{
    doOrderbump = false;
  }
  */

  //<>--<>--<>--<>--<>--<>--<>--<>--<>--<>--<>--<>--<>--<>--<>--<>
  if(doOrderbump){
    //return renderOrderbump(orderbump, index, productId);
   // console.log("Orderbump state: ",orderbumploading);
   // console.log("currentIndex: ",currentIndex);
   // console.log("This Index: ",index);
    
  if(orderbumploading && (currentIndex === index)){
    return <SkeletonContent/>;
  }else{
    return <Orderbumpelement orderbump={orderbump} index={index} productId={productId} currency={settings.currency} selectedOrderbumps={selectedOrderbumps} toggleOrderbumpSelection={toggleOrderbumpSelection} handleCheckboxChange={handleCheckboxChange}/>;
  }
  }else{

   return null;
  }
  //<>--<>--<>--<>--<>--<>--<>--<>--<>--<>--<>--<>--<>--<>--<>--<>

}
















  const handleCloseVariablePopup = () => {
   // console.log("Close Popup");
   // console.log("SelectedOrderbumps: ",selectedOrderbumps);
    setShowVariablePopup(false); // Funktion zum Schließen des Popups
    setSelectedOrderbumps([]); // Entferne den aktuellen Orderbump-Index
  };





  return (
    <div id="ips_order_bumps_below_cart_items" className="content-orderbumps-element">
    {/* Popup-Komponente */}
    <VariablePopup show={showVariablePopup} orderbump={currentOrderbump} baseurl={settings.base_url} selectedPrice={selectedPrice} setSelectedPrice={setSelectedPrice} orderbumpAddToCart={orderbumpAddToCart} handleClose={handleCloseVariablePopup} />

    {/* Rendering der Orderbumps */}
    {settings.orderbumpsoptions.map(shouldRenderOrderbump)}
  </div>
  );
}





  


export default Orderbump;